import { inject, Injectable } from '@angular/core';
import { Actions, createEffect, ofType } from '@ngrx/effects';
import { of } from 'rxjs';
import { catchError, map, switchMap } from 'rxjs/operators';

import { DifferenceFailure, DifferenceRequest, DifferenceSuccess } from './actions';
import { DifferenceService } from './service';

@Injectable()
export class DifferenceEffects {
  private readonly actions$ = inject(Actions);
  private readonly differenceService = inject(DifferenceService);

  publicdifference$ = createEffect(() =>
    this.actions$.pipe(
      ofType(DifferenceRequest),
      switchMap(({ parameters }) =>
        this.differenceService.difference(parameters).pipe(
          map(data => DifferenceSuccess({ data })),
          catchError(error => of(DifferenceFailure({ error })))
        )
      )
    )
  );

}
